import { i18nSymbol } from '@/i18n';
import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
export const useI18n = createSharedComposable(() => {
    const i18n = injectService(i18nSymbol);
    const t = i18n.t.bind(i18n);
    const tc = i18n.tc.bind(i18n);
    const te = i18n.te.bind(i18n);
    const locale = i18n.locale;
    return {
        t,
        tc,
        te,
        locale,
        i18n,
    };
});
